// import { CourseOverviewViewContentButton } from 'src/components/courseOverview/courseOverviewActionButton/_courseOverviewViewContentButton/CourseOverviewViewContentButton';
import { ContentDetailItem } from 'src/types/ContentDetailsItem';

import { LoginFormFields } from 'src/components/account/Login/LoginFormFields';

import ContentDetailFields from '../ContentDetailFields';

import { ContentDetailsHeader } from './_ContentDetailTypesComponents/ContentDetailsHeader';
// import useContentAccessLevel from 'src/hooks/useContentAccessLevel';
import { ContentDetailsMain } from './_ContentDetailTypesComponents/ContentDetailsMain';

import ctaStyles from '../CourseDetailCallToAction.module.css';
import overviewStyles from '../CourseDetailOverview.module.css';

type CpdArticleProps = {
	ContentDetail: ContentDetailItem;
	fields: ContentDetailFields & LoginFormFields;
};

export function CPDArticle(props: CpdArticleProps): JSX.Element {
	// const { isAllowedAccessToContent } = useContentAccessLevel(props.ContentDetail.Access);

	return (
		<section className="maxWidth">
			<header className={`${ctaStyles.row} padX`}>
				<ContentDetailsHeader
					AccessType={props.fields.AccessType}
					LearningType={props.ContentDetail.LearningTypeString}
					AccessTypesString={props.ContentDetail.AccessTypesString}
					LearningFormats={props.ContentDetail.LearningFormats}
					TypesOfResourcesString={props.ContentDetail.TypesOfResourcesString}
					OpenAccessText={props.fields.OpenAccessText}
					RegisteredUserText={props.fields.RegisteredUserText}
					RCNMemberText={props.fields.RCNMemberText}
					RCNiPlusSubscriberText={props.fields.RCNiPlusSubscriberText}
					OrganisationalProductText={props.fields.OrganisationalProductText}
					Cost={props.ContentDetail.Cost}
					Location={props.ContentDetail.Location}
				/>

				{/* <CourseOverviewViewContentButton
					allowedAccess={isAllowedAccessToContent}
					Url={props.ContentDetail.Url}
				/> */}
			</header>

			<main className={`${overviewStyles.section} padX`}>
				<ContentDetailsMain
					Information={props.ContentDetail.Information}
					CertificateOfCompletion={props.ContentDetail.CertificateOfCompletion}
					CertificateOfCompletionText={props.fields.CertificateOfCompletionText}
					YesCertificateText={props.fields.YesCertificateText}
					NoCertificateText={props.fields.NoCertificateText}
					DateReviewed={props.ContentDetail.DateReviewed}
					DateReviewedText={props.fields.DateReviewedText}
					DateReviewedTextPlaceholder={props.fields.DateReviewedTextPlaceholder}
					ProfessionalLeads={props.ContentDetail.ProfessionalLeads}
					AuthorsText={props.fields.AuthorsText}
					ProfessionalLeadsTextPlaceholder={props.fields.ProfessionalLeadsTextPlaceholder}
					ResourceSponsor={props.ContentDetail.ResourceSponsor}
					ResourceSponsorText={props.fields.ResourceSponsorText}
					HasAccess={props.ContentDetail.Access?.RcniPlusSubscriber.AllowAccess}
					QualityAssuranceText={props.fields.QualityAssuranceText}
				/>
			</main>
		</section>
	);
}
